(function () {
	'use strict';

	angular.module('eclipseApp.checkout')

	.factory('authUtils', ['$q', '$rootScope', function ($q, $rootScope) {
		var authUtils = {
			isAuth: function(){
        console.log('@authUtils --1');
				return ($rootScope.ruiMethods.user.is.loggedIn() || $rootScope.ruiMethods.user.is.agent());
			},
			isLoggedIn: function(){
        console.log('@authUtils --2');
				return $rootScope.ruiMethods.user.is.loggedIn();
			},
			isAgent: function(){
        console.log('@authUtils --3');
				return $rootScope.ruiMethods.user.is.agent();
			}
		};
		return authUtils;
	}]);

})();
